<template>
	<div class='knd-article-icon knd-icon-link' v-on:click="copyUrl">
		<LinkIcon />
		<div class='copy-label' ref='label'>url gekopieerd</div>
	</div>			
</template>

<script>
	import LinkIcon from '@/assets/icons/link.svg?inline';

	const vueObject = {
		props: ['id'],
		components: {
			LinkIcon
		},
		mounted: function() {},
		methods: {
			copyUrl() {
				let id = this.id;
				this.$router.push({ query: Object.assign({}, this.$route.query, { article: id }) });

				let url = this.$router.currentRoute.value.fullPath;
				this.copyToClipboard(document.location.host + document.location.pathname + '#' + url);

				this.$refs.label.classList.add('show')
				setTimeout((d) => {
					this.$refs.label.classList.remove('show')
				}, 1000);
			},

			copyToClipboard(str) {
				const el = document.createElement('textarea');
				el.value = str;
				el.setAttribute('readonly', '');
				el.style.position = 'absolute';
				el.style.left = '-9999px';
				document.body.appendChild(el);
				el.select();
				document.execCommand('copy');
				document.body.removeChild(el);
			}
		}
	}

	export default vueObject;
</script>